import { graphql } from "@opensea/graphql"
import { ListingFlowItemsTableRowFragment } from "./ListingFlowItemsTableRow.fragment"

export const ListingFlowItemsTableFragment = graphql(
  `
    fragment ListingFlowItemsTable on Item {
      id
      ...ListingFlowItemsTableRow
    }
  `,
  [ListingFlowItemsTableRowFragment],
)
